import { DateTime } from 'luxon';

export const getLocaleTime = (date: string): string => {
  return DateTime.fromISO(date, { zone: 'Europe/Paris' }).toFormat("HH'h'mm", {
    locale: 'fr',
  });
};

export const getLocaleDate = (date: string): string => {
  return DateTime.fromISO(date, { zone: 'Europe/Paris' }).toFormat(
    'dd/MM/yyyy',
    {
      locale: 'fr',
    },
  );
};
